export function parseKinescopeLink(url: string) {
    const matches = /https?:\/\/kinescope\.io\/([^/]+\/)*([^/?]+)/.exec(url)
    if (matches) return { id: matches[2] }
}
